<template>
    <div class="attachments-form1">
        <div class="head-buttons">
            <b-button
                class="edit-info-btn"
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
                v-if="getEditionMode"
            >
                Editar informações
            </b-button>

            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                @click="addAttachment()"
                v-if="showLock && (!getEditionMode || (getEditionMode && !getIsDisabled))"
            >
                Adicionar mais anexos
            </b-button>

            <div class="help-message-btn" @click="showModal('know-more-modal-ref')">
                <div>
                    <img :src="require(`@/assets/Cadastro/responsavel/help-icon.svg`)" alt="" />
                    <div class="text">
                        Saiba mais
                    </div>
                </div>
            </div>
        </div>

        <div class="lock-message" v-if="showLock">
            <LockPP :statusLock="0" />

            <div class="text">
                Caso queira que suas informações não sejam públicas, clique no icone do cadeado para ocultar.
            </div>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <h6 v-if="!form.attachments.length">
                Clique no botão "Adicionar mais anexos"
            </h6>

            <div v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['anexos'].value)">
                <div class="attachment-field" v-for="(item, index) in form.attachments" :key="index">
                    <div v-if="item.show">
                        <h6>Anexo</h6>

                        <b-form-group label="Nome do documento" label-for="fileName">
                            <b-form-input
                                name="fileName"
                                v-model="item.fileName"
                                placeholder="Digite aqui"
                                :disabled="getIsDisabled"
                            ></b-form-input>

                            <LockPP
                                :statusLock="item.isLock"
                                :lockMsg="'Privado'"
                                :unlockMsg="'Público'"
                                @click="item.isLock = Number(!item.isLock)"
                                v-if="showLock"
                            />
                        </b-form-group>

                        <FormFilePP
                            :ref="'fileRef_' + index"
                            :text1="textFile1"
                            :text2="textFile2"
                            :singleFile="true"
                            :disabled="getIsDisabled"
                            :previewImg="true"
                            :singleFileData="getSingleFileData(index)"
                            :urlSingleFileData="item.urlSingleFileData"
                            :showSingleFile="!receiveData"
                            @removeSingleFile="removeSingleFile(index)"
                            v-if="item.show"
                        />

                        <b-button
                            size="sm"
                            variant="danger"
                            @click="removeAttachment(index)"
                            v-if="showLock && (!getEditionMode || (getEditionMode && !getIsDisabled))"
                        >
                            Excluir
                        </b-button>
                    </div>
                </div>
            </div>

            <NoAuthorizationMsgPP v-if="isPlatform && getAuthorizationData && !getAuthorizationData['anexos'].value" />

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'GovernanceForm10' })"
                    v-if="!showFooterButtons"
                >
                    Voltar
                </b-button>

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons">
                    Próximo
                </b-button>

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('GovernanceForm10')">Voltar</b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="know-more-modal-ref"
            title="Informações"
            body-class="know-more-body-modal"
            ok-only
            ok-title="Fechar"
            ok-variant="secondary"
            size="lg"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <div class="text">{{ knowMoreContent }}</div>
            </div>
        </b-modal>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <SuccessMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="$router.push({ name: 'MyProfilePage' })">
                    Visualizar meu perfil
                </b-button>

                <b-button variant="secondary" @click="$router.push({ name: 'OpportunityPanel' })">
                    Painel de oportunidades
                </b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import FormFilePP from '@/ui/form-file-pp/FormFilePP'
import LockPP from '@/ui/lock-pp/LockPP'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import { AttachmentsApi } from '../../api/attachments'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const attachmentsApi = new AttachmentsApi()

export default {
    components: { FormFilePP, LockPP, SuccessMsgModal, DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            count: 0,
            progress: 100.0,
            isUpdate: false,
            attachments: null,
            isDisabled: null,
            message: null,
            authorizationData: null,
            textFile1: 'Tamanho de upload de imagem para 2 Mb e para PDF 10 Mb',
            textFile2: 'Arquivos suportados: .png. .pdf, .jpg',
            knowMoreContent:
                'Obs.: Nesta seção, é possível inserir anexos de documentos que você pensa ser importante divulgar (ex. logo, estatuto, cartão CNPJ, certidões negativas, certificados (OSCIP, isenção ITMCD, Entidade Defensora de DH, dentre outras), clipping, planejamento estratégico, teoria da mudança, dashboard, etc',
            form: {
                attachments: []
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress', 'setShowGamificationProgress']),
        fetchRead() {
            const data = this.receiveData

            this.form.attachments = data.anexos.map(item => ({
                fileName: item.nome_doc,
                url: item.url_doc,
                isLock: item.view_anexos,
                singleFileData: null,
                urlSingleFileData: null,
                show: true
            }))

            this.loadingFiles(data)

            this.fetchAuthorization()
        },
        fetch() {
            if (this.getProgress === '96.95') {
                this.setShowGamificationProgress(true)

                setTimeout(() => {
                    this.setShowGamificationProgress(false)
                }, 12000)
            }

            this.usuario = JSON.parse(localStorage.getItem('usuario'))
            this.setIsLoading(true)

            axios
                .all([attachmentsApi.getAttachments()])
                .then(response => {
                    const data = response[0].data.data

                    if (data !== null) {
                        this.attachments = data

                        this.form.attachments = data.anexos.map(item => ({
                            fileName: item.nome_doc,
                            url: item.url_doc,
                            isLock: item.view_anexos,
                            singleFileData: null,
                            urlSingleFileData: null,
                            show: true
                        }))

                        this.loadingFiles(data)

                        this.setProgress(data.percentual)
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        loadingFiles(data) {
            this.form.attachments.forEach((at, index) => {
                if (data.anexos[index].url_doc) {
                    at.singleFileData = {
                        name: data.anexos[index].url_doc.split('.')[0],
                        type: data.anexos[index].url_doc.split('.')[1]
                    }

                    at.urlSingleFileData = this.$PPP_URL_FILE + data.anexos[index].url_doc
                }
            })
        },
        getSingleFileData(index) {
            return this.form.attachments[index].singleFileData
        },
        removeSingleFile(index) {
            this.form.attachments[index].urlSingleFileData = null
            this.form.attachments[index].url = null
            this.form.attachments[index].urlSingleFileData = null
        },
        onSubmit() {
            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const data = {
                percentual: currentProgress
            }

            if (this.form.attachments.length) {
                data.anexos = this.form.attachments
                    .map((item, index) => {
                        if (!item.show) {
                            return false
                        }

                        const fileData = {
                            nome_doc: item.fileName,
                            url_doc: item.url,
                            view_anexos: item.isLock
                        }

                        if (this.$refs['fileRef_' + index][0] && this.$refs['fileRef_' + index][0].image) {
                            fileData.url_doc = this.$refs['fileRef_' + index][0]
                                ? this.$refs['fileRef_' + index][0].image
                                : null
                        }

                        return fileData
                    })
                    .filter(at => at !== false)
            } else {
                data.anexos = []
            }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? attachmentsApi.updateAttachments(data)
                : attachmentsApi.createAttachments(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.message = response.data.message
                    this.isUpdate ? this.changeStatusDisabled(true) : this.showModal('warning-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'AttachmentsForm1' })
        },
        addAttachment() {
            // this.count += 1
            // this.attachmentsIds.push(this.count)

            this.form.attachments.push({
                fileName: null,
                url: null,
                isLock: 1,
                singleFileData: null,
                urlSingleFileData: null,
                show: true
            })
        },
        removeAttachment(index) {
            this.form.attachments[index].show = false
            // this.attachmentsIds.splice(index, 1)
            // this.$refs.splice(index, 1)
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAttachments(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AttachmentsForm1-light-theme.css"></style>
<style scope src="./AttachmentsForm1-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-attachments-forms/AttachmentsForm1.vue